module.exports = __webpack_public_path__ + "img/logoMapa.1a9fab81.png";